import { CustomerPhotoReview, ReviewStatus } from '../types';

export const customerPhotoReviews: CustomerPhotoReview[] = [
  {
    id: 1,
    name: 'Betuel Rubio',
    initial: 'B',
    country: 'México',
    overallRating: 5,
    date: '30/7/2024',
    comment: 'Excelente',
    subRatings: [
      { label: 'Calidad', rating: 4 },
      { label: 'Precio', rating: 5 },
    ],
    images: [
      'https://i.imgur.com/2s4x7x8.png',
      'https://i.imgur.com/8Qp4S3q.png',
    ],
    status: ReviewStatus.Aprobada,
  },
  {
    id: 2,
    name: 'Ana García',
    initial: 'A',
    country: 'México',
    overallRating: 4,
    date: '25/7/2024',
    comment: 'Buena calidad, el envío tardó un poco.',
    subRatings: [
      { label: 'Calidad', rating: 5 },
      { label: 'Precio', rating: 4 },
    ],
    images: [
      'https://i.imgur.com/gT3FNU5.jpeg',
      'https://i.imgur.com/J7b4Hj2.jpeg',
      'https://i.imgur.com/w1sBC2X.jpeg',
    ],
    status: ReviewStatus.Aprobada,
  },
  {
    id: 3,
    name: 'Carlos Mendoza',
    initial: 'C',
    country: 'México',
    overallRating: 5,
    date: '22/7/2024',
    comment: 'Todo perfecto, como siempre.',
    subRatings: [
      { label: 'Calidad', rating: 5 },
      { label: 'Precio', rating: 5 },
    ],
    images: [
      'https://i.imgur.com/k2tCjDf.png',
      'https://i.imgur.com/gS21gE6.png',
      'https://i.imgur.com/jVqD4x0.jpeg',
      'https://i.imgur.com/7D2p3uu.png',
    ],
    status: ReviewStatus.Aprobada,
  },
  {
    id: 4,
    name: 'Sofia Hernandez',
    initial: 'S',
    country: 'México',
    overallRating: 5,
    date: '18/7/2024',
    comment: '¡Servicio al cliente de primera!',
    subRatings: [
      { label: 'Calidad', rating: 5 },
      { label: 'Precio', rating: 4 },
    ],
    images: [
      'https://i.imgur.com/G5331gA.png',
      'https://i.imgur.com/8aLb584.png',
      'https://i.imgur.com/G7B1H8h.png',
    ],
    status: ReviewStatus.Aprobada,
  },
  {
    id: 5,
    name: 'Luis F. Espinosa',
    initial: 'L',
    country: 'México',
    overallRating: 4,
    date: '15/7/2024',
    comment: 'El gramaje del producto no corresponde. Calidad muy buena!!!',
    subRatings: [
      { label: 'Calidad', rating: 5 },
      { label: 'Precio', rating: 3 },
    ],
    images: [
      'https://i.imgur.com/83p1E7O.png',
      'https://i.imgur.com/O42k2jW.jpeg',
      'https://i.imgur.com/Jd1mNfT.jpeg',
      'https://i.imgur.com/GzB9Z8x.jpeg',
      'https://i.imgur.com/U1Nf4Y5.jpeg',
    ],
    status: ReviewStatus.Aprobada,
  },
];
